import { useContext } from 'react'
import { FeatureFlagsContext } from '~/context/featureFlags'

export default function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}
